<div class="support" [class.admin]="admin" [class.clickable]="admin" (click)="openModal()">
	<div *ngIf="linkInfo?.supportInformation else noInfo" [innerHTML]="linkInfo.supportInformation">
	</div>
	<ng-template #noInfo>
		<p>There is no support information at this time</p>
	</ng-template>
	<i *ngIf="admin" class="far fa-pen"></i>
</div>

<al-link-edit-info-modal></al-link-edit-info-modal>
